export default {
  app: {
    privacy: {
      policy: 'Палітыка прыватнасці',
      expansive: 'Выкарыстоўваючы Expansive, вы згаджаецеся з Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Сесія скончылася',
    sessionExpiredDescription:
      'Ваша сесія скончылася. Калі ласка, увайдзіце зноў, каб працягнуць выкарыстанне прыкладання.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Выбраць мову',
      chooseLanguageDescription:
        'Выберыце пераважную мову для прыкладання. Гэта зменіць мову інтэрфейсу і зместу.',
    },
    userSelection: {
      cancel: 'Адмяніць',
      createNewUser: 'Іх імя не ў спісе',
      newUser: 'Новы карыстальнік',
      selectAnExistingUser: 'Выбраць існуючага карыстальніка',
      selectUserHint: 'Выберыце існуючага карыстальніка або стварыце новага, каб працягнуць.',
      startTypingToSearch: 'Пачніце ўводзіць...',
    },
    verification: {
      codeVerification: {
        continue: 'Працягнуць',
        header: 'Увядзіце код доступу да аб’екта',
        invalidCode: 'Няправільны код, паспрабуйце яшчэ раз.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Працягнуць без праверкі месцазнаходжання',
        enterSiteAccessCode: "Увядзіце код доступу да аб'екта",
        locationNotEnabledOrAvailable: 'Чаму я бачу гэта?',
        notAvailable: {
          description: 'GPS-месцазнаходжанне не падтрымліваецца на гэтай прыладзе.',
          header: 'Месцазнаходжанне не падтрымліваецца',
        },
        notEnabled: {
          description: 'Службы месцазнаходжання не ўключаны або дазвол не нададзены.',
          header: 'Месцазнаходжанне не ўключана',
        },
        notVerified: {
          description: 'GPS паказвае, што вы не на аб’екце.',
          header: 'Месцазнаходжанне не пацверджана',
        },
        tryAgain: 'Паспрабуйце яшчэ раз',
        unavailable: {
          description: 'Мы не змаглі пацвердзіць ваша месцазнаходжанне GPS.',
          header: 'Месцазнаходжанне недаступна',
        },
        unknown: {
          description: 'Мы не можам вызначыць ваша месцазнаходжанне.',
          header: 'Месцазнаходжанне невядома',
        },
        verified: {
          description: 'GPS паказвае, што вы на аб’екце.',
          header: 'Месцазнаходжанне пацверджана',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Актывы не знойдзены',
        emptyDescription: 'З гэтым заказам на працу не звязаныя ніякія актывы.',
        warrantyParts: 'Гарантыя на часткі сканчаецца',
        serialNumber: 'Серыяльны нумар',
        none: '<няма>',
      },
      updates: {
        emptyTitle: 'Абнаўлення не знойдзены',
        emptyDescription: 'Для гэтага заказу на працу няма абнаўленняў.',
        unknownUser: 'Невядомы карыстальнік',
        none: 'Няма',
        addComment: {
          buttonLabel: 'Дадаць каментар',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Небяспекі',
          no: 'Не',
          yes: 'Так',
        },
      },
    },
    attachmentsList: {
      attachments: 'Укладанні',
      documents: 'Документы',
      siteDocuments: 'Сайтавыя дакументы',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Небяспекі',
        induction: 'Уводзіны',
        safeToProceed: 'Бяспечна працягваць',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Тэрмін выканання',
        activeSessions: 'Актыўныя сесіі',
        activeSessionsDescription:
          'Вы ўжо зарэгістраваны на наступныя заказы на працу. Вам трэба выйсці з гэтых заказаў, перш чым рэгістравацца на новы заказ.',
        resumeSession: 'Працягнуць',
        startTime: 'Пачатак у',
        unexpectedErrorTitle: 'Непрадбачаная памылка',
        unexpectedErrorMessage:
          'Адбылася непрадбачаная памылка падчас спробы стварыць вашы сесіі. Калі ласка, паспрабуйце яшчэ раз пазней.',
        engineerNotFound: 'Інжынер не знойдзены',
        engineerNotFoundDescription:
          'Інжынер, якога вы спрабуеце зарэгістраваць, не знойдзены ў сістэме. Калі ласка, звяжыцеся з вашым адміністратарам.',
      },
      verification: {
        code: {
          description:
            'Каб зарэгістравацца, атрымаеце 4-значны код у кіраўніка аб’екта або ў прызначанага кантакту.',
        },
        geo: {
          continue: 'Працягнуць',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Калі ласка, атрымайце код доступу ад кіраўніка пляцоўкі альбо прызначанага кантакту для завяршэння вашага візіту.',
            checkOut: 'Выйсці',
            completeBeforeLeaving: 'Калі ласка, запоўніце наступную форму перад тым, як пакінуць.',
            continue: 'Працягнуць',
            noResolutionSelected: 'Калі ласка, выберыце рашэнне перад працягам.',
            quoteRequired: {
              hint: 'Візіт завершаны, цана будзе пазней',
              label: 'Трэба цана',
            },
            returnVisitRequired: {
              hint: 'Мы вернемся, каб завяршыць',
              label: 'Трэба паўторны візіт',
            },
            serviceCompleted: {
              hint: 'Далейшыя дзеянні не патрабуюцца',
              label: 'Служба завершана',
            },
            uploadCheckout: 'Загрузіце файл, фота або відэа',
            visitNotes: 'Запіскі аб візіце',
            workOrderResolution: 'Рашэнне па заказу на працу',
            enterNotes: 'Увядзіце любыя заўвагі тут...',
            errors: {
              timedOut:
                'Час чакання скончыўся, перавысіў 30 секунд. Калі ласка, паспрабуйце яшчэ раз.',
              closingSession: 'Памылка пры закрыцці сесіі',
            },
          },
          success: {
            description:
              'Дзякуй за візіт на {site}. | У {site} застаўся 1 адкрыты заказ на працу. | У {site} засталося {count} адкрытых заказаў на працу.',
            endVisit: 'Завяршыць візіт',
            header: 'Вы паспяхова выйшлі',
            viewWorkOrders: 'Зарэгістравацца на іншы заказ',
          },
          verification: {
            code: {
              description:
                'Каб выйсці, атрымаеце 4-значны код у кіраўніка аб’екта або ў прызначанага кантакту.',
              continue: 'Працягнуць',
            },
            geo: {
              checkOut: 'Выйсці',
              continue: 'Працягнуць',
            },
          },
        },
        detail: {
          assets: 'Актывы',
          call: 'Тэлефонны званок',
          checkOut: 'Выйсці',
          closed: 'Зачынена',
          details: 'Дэталі',
          dueBy: 'Тэрмін выканання',
          manageEngineers: 'Кіраванне інжынерамі',
          notAvailable: 'Не даступна',
          pointOfContact: 'Кантактная асоба',
          siteAccessTimes: "Час доступу на аб'ект",
          siteAccessInstructions: 'Інструкцыі па доступу',
          siteAddress: "Адрас аб'екта",
          siteNotes: 'Заўвагі аб’екта',
          siteTelephone: 'Тэлефон аб’екта',
          siteLocation: 'Месцазнаходжанне аб’екта',
          updates: 'Абнаўлення',
          more: 'Больш',
          mismatchErrorTitle: 'Памылка заказу на працу',
          mismatchErrorMessage:
            'Заказ на працу, да якога вы спрабуеце атрымаць доступ, не адпавядае таму, у які вы зараз зарэгістраваны. Калі ласка, праверце свой заказ на працу і паспрабуйце яшчэ раз.',
          siteDocuments: 'Сайтавыя дакументы',
          validFrom: 'Дзейнічае з',
          validUntil: 'Дзейнічае па',
          documentName: 'Назва дакумента',
          documentType: 'Тып дакумента',
          attachments: 'Файлы заказу на працу',
          download: 'Спампаваць',
          workDetails: 'Дэталі працы',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Дадаць дапаможнага інжынера',
            assistantEngineers: 'Дапаможныя інжынеры',
            description:
              'Па прычынах бяспекі, калі ласка, укажыце імёны кожнага інжынера на аб’екце.',
            editMainEngineer: 'Рэдагаваць галоўнага інжынера',
            errors: {
              creatingEngineer: 'Памылка пры стварэнні інжынера',
              creatingSession: 'Памылка пры стварэнні сесіі',
            },
            header: 'Інжынеры на аб’екце',
            mainEngineer: 'Галоўны інжынер',
            newAssistantEngineer: 'Увядзіце яго поўнае імя',
            next: 'Далей',
            removeEngineer: 'Выдаліць інжынера',
            selectExistingAssistantEngineer: 'Пачніце ўводзіць яго імя',
          },
          index: {
            description:
              'Па прычынах бяспекі, калі ласка, укажыце імёны кожнага інжынера на аб’екце.',
            errorCreatingEngineer:
              'Памылка пры стварэнні інжынера, калі ласка, паспрабуйце яшчэ раз.',
            header: 'Інжынеры на аб’екце',
            hintMainEngineer: 'Увядзіце поўнае імя галоўнага інжынера',
            newMainEngineer: 'Новы галоўны інжынер',
            next: 'Далей',
            selectExistingMainEngineer: 'Выберыце існуючага галоўнага інжынера',
            yes: 'Так',
            no: 'Не',
            mainEngineerLabel: 'Вы галоўны інжынер?',
          },
        },
        index: {
          callUsOn: 'Тэлефануйце нам па нумары {phoneNumber}',
          description: 'Не можаце знайсці тое, што шукаеце?',
          dueBy: 'Тэрмін выканання',
          header: 'Выберыце заказ на працу',
          notAvailable: 'Не даступна',
          searchWorkOrders: 'Пошук заказаў на працу...',
        },
        manageEngineers: {
          manageEngineers: 'Кіраванне інжынерамі',
          notWorking: 'Неактыўныя работнікі',
          pause: 'Паўза',
          resume: 'Працягнуць',
          workingNow: 'Актыўныя работнікі',
          startTime: 'Час пачатку',
          endTime: 'Час заканчэння',
          duration: 'Працягласць',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Зваротная сувязь',
            feedbackDescription:
              'Калі ласка, пакіньце водгук па заказу на працу, каб дапамагчы нам палепшыць нашы паслугі.',
            feedbackLabel: 'Зваротная сувязь',
            filesLabel: 'Укладанні',
            submissionLabel: 'Адправіць водгук',
          },
          hazards: {
            back: 'Назад',
            hazards: 'Небяспекі',
            next: 'Далей',
            no: 'Не',
            noTasksForHazard: 'Для гэтай небяспекі няма задач для выканання.',
            yes: 'Так',
          },
          induction: {
            continue: 'Працягнуць',
            induction: 'Уводзіны',
          },
          index: {
            checkIn: 'Зарэгістравацца',
            description: 'Калі ласка, завяршэце наступную ацэнку рызыкі для выбранай працы.',
            fail: 'Не ўдалося апрацаваць праверку пачатку заказу на працу.',
            haltMessage:
              'Выяўлены патэнцыйныя рызыкі. Калі ласка, спыніце працу, перагледзьце правілы бяспекі і звяжыцеся з вашым кіраўніком для атрымання дадатковых інструкцый.',
            header: 'Праверкі перад пачаткам працы',
            endVisit: 'Завяршыць візіт',
            leaveFeedback: 'Пакінуць водгук',
          },
          safeToProceed: {
            continue: 'Працягнуць',
            safeToProceed: 'Бяспечна працягваць',
          },
        },
      },
    },
    index: {
      title: 'Сардэчна запрашаем',
      description: 'Скануйце QR-код у вашым месцазнаходжанні, каб пачаць.',
    },
    login: {
      errorTitle: 'Непрадбачаная памылка',
      errorMessage:
        'Адбылася непрадбачаная памылка. Калі ласка, паспрабуйце зноў сканаваць QR-код.',
    },
    unauthenticated: {
      welcome: {
        title: 'Сардэчна запрашаем у {site}',
        description:
          'Перш чым мы зможам паказаць вам якія-небудзь заказы на працу, нам трэба праверыць вашыя дадзеныя. Націсніце кнопку ніжэй, каб працягнуць.',
        next: 'Працягнуць',
      },
      index: {
        errorTitle: 'Непрадбачаная памылка',
        errorMessage:
          'Адбылася непрадбачаная памылка. Калі ласка, паспрабуйце зноў сканаваць QR-код.',
      },
      contractor: {
        title: 'На каго вы працуеце?',
        contractor: 'Падрадчык',
        contractorLabel: 'Пачніце ўводзіць назву вашай кампаніі',
        contractorHint: 'Вы павінны ўвесці 3 і больш сімвалаў, каб убачыць вынікі',
        defaultSelectPlaceholder: '--Калі ласка, выберыце--',
        next: 'Далей',
      },
      user: {
        title: 'Хто вы?',
        cancel: 'Адмяніць',
        createNewUserLabel: 'Мае імя няма ў спісе',
        existingUserLabel: 'Пачніце ўводзіць сваё імя',
        existingUserHint: 'Вы павінны ўвесці 3 і больш сімвалаў, каб убачыць вынікі',
        newUserLabel: 'Увядзіце сваё поўнае імя',
        next: 'Далей',
        user: 'Карыстальнік',
      },
      verification: {
        methods: {
          add: {
            add: 'Дадаць метад праверкі',
            defaultSelectPlaceholder: '--Калі ласка, выберыце--',
            emailLabel: 'Электронная пошта',
            existingMethodWarning:
              'Вы ўжо маеце чаканне на зацвярджэнне гэтага метаду праверкі ад адміністратара. Даданне новага перапішэ яго.',
            method: 'Метад',
            methodLabel: 'Метад',
            mobileCountryHint: 'Калі ласка, выберыце код вашай краіны',
            mobileCountryLabel: 'Код краіны мабільнага тэлефона',
            mobileHint: 'Калі ласка, увядзіце свой мабільны нумар',
            mobileLabel: 'Мабільны',
            title: 'Дадаць метад праверкі',
          },
          confirm: {
            confirm: 'Пацвердзіць',
            description: 'Калі ласка, пацвердзіце свой метад праверкі, каб працягнуць.',
            label: 'Увядзіце свой код',
            resend: 'Паўторна адправіць',
            resendPrompt: 'Не атрымалі код?',
            title: 'Пацвердзіць метад праверкі',
          },
          confirmed: {
            description:
              'Вы будзеце паведамлены, як толькі гэты метад праверкі будзе зацверджаны вашым адміністратарам, і тады вы зможаце пачаць выкарыстоўваць яго для праверкі сваёй асобы.',
            forceApproval:
              'Пакуль ён не будзе зацверджаны, вы не зможаце атрымаць доступ да заказаў на працу.',
            nonForceApproval:
              'Тым часам вы можаце працягваць атрымліваць доступ да заказаў на працу з абмежаваным доступам.',
            nonForceApprovalButtonLabel: 'Працягнуць з абмежаваным доступам',
            title: 'Чакаем зацвярджэння',
          },
          addNew: 'Дадаць новы метад праверкі',
          description:
            'Нам трэба праверыць вашу асобу, каб даць вам поўны доступ да заказу на працу.',
          email: 'Электронная пошта',
          hint: 'Мы адправім спасылку на ваш абраны метад праверкі, якая дае вам поўны доступ да заказу на працу. Калі вам трэба змяніць якія-небудзь існуючыя метады праверкі, калі ласка, звяжыцеся з вашым адміністратарам.',
          label: 'Выберыце метад праверкі',
          next: 'Далей',
          pendingHint: 'Чакаем зацвярджэння ад вашага адміністратара',
          sms: 'SMS',
          title: 'Праверка',
        },
        optional: {
          hint: 'Праверка вашых дадзеных карыстальніка дасць вам поўны доступ да заказу на працу',
          label: 'Ці хочаце вы праверыць свае дадзеныя карыстальніка?',
          next: 'Далей',
          no: 'Не',
          noHint:
            'Я не хачу правяраць свае дадзеныя карыстальніка і працягваць з абмежаваным доступам да заказу на працу',
          title: 'Праверка',
          yes: 'Так',
          yesHint:
            'Я хачу праверыць свае дадзеныя карыстальніка і атрымаць поўны доступ да заказу на працу',
        },
        sent: {
          description:
            'Спасылка для ўваходу была адпраўлена на {identifier}. Калі ласка, націсніце на спасылку, каб завяршыць уваход.',
          title: 'Спасылка для ўваходу адпраўлена',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Учора',
      today: 'Сёння',
      days: {
        monday: 'Понедзелак',
        tuesday: 'Аўторак',
        wednesday: 'Серада',
        thursday: 'Чацвер',
        friday: 'Пятніца',
        saturday: 'Субота',
        sunday: 'Нядзеля',
      },
      months: {
        january: 'Студзень',
        february: 'Люты',
        march: 'Сакавік',
        april: 'Красавік',
        may: 'Май',
        june: 'Чэрвень',
        july: 'Ліпень',
        august: 'Жнівень',
        september: 'Верасень',
        october: 'Кастрычнік',
        november: 'Лістапад',
        december: 'Снежань',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Штосьці пайшло не так',
      message: 'Калі ласка, паспрабуйце зноў сканаваць QR-код.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Невядомы карыстальнік',
      },
      none: 'Няма',
      types: {
        stateTransition: 'Статус змяніўся',
        contractorAssigned: 'Падрадчык прызначаны',
        engineerAssigned: 'Інжынер прызначаны',
        serviceAssigned: 'Служба прызначана',
        priorityChanged: 'Прыярытэт змяніўся',
        actionableDateChanged: 'Дата дзеяння змянілася',
        dueDateChanged: 'Дата заканчэння змянілася',
        etaDateChanged: 'Дата прыкладнага прыбыцця змянілася',
        spendLimitApproved: 'Ліміт выдаткаў зацверджаны',
        spendLimitCancelled: 'Запыт на ліміт выдаткаў адменены',
        spendLimitRejected: 'Ліміт выдаткаў адхілены',
        spendLimitRequested: 'Запыт на ліміт выдаткаў',
        jobSheetUploaded: 'Ліст працы загружаны',
        slaAlertSent: 'Час увагі парушае SLA-апавяшчэнне',
        issuedWorkPermit: 'Выдадзены працоўны дазвол',
        requestForServiceSent: 'Запыт на паслугу адпраўлены',
        comment: 'Каментар дададзены',
        unknown: 'Невядомая падзея',
      },
      labels: {
        actionableDate: 'Дата дзеяння',
        comment: 'Каментар',
        file: 'Файл',
        contractor: 'Падрадчык',
        dueDate: 'Дата заканчэння',
        etaDate: 'Дата прыкладнага прыбыцця',
        engineer: 'Інжынер',
        priority: 'Прыярытэт',
        requestForService: 'Запыт на паслугу',
        service: 'Служба',
        spendLimit: 'Ліміт выдаткаў',
        status: 'Статус',
        workPermit: 'Працоўны дазвол',
      },
    },
  },
}
